/**
 * MEXC Spot Trade History API の設定定義。
 * README の「基本情報」を基に、同期処理で利用する ApiConfig を定義する。
 */
import type { ApiConfig } from '../../types'

export const spotTradeHistoryApiConfig = {
  // シンボル ("BTC/USDT" のような形式) をサブタイプとして要求
  existSubType: true,
  // 遡って取得できる最大期間: 1ヶ月 (30日)
  fetchableRange: (30 * 24 - 1) * 60 * 60 * 1000, // 30 days in milliseconds
  // API の 1 回の最大取得件数
  limit: 100,
  // 取得順序 (最新から過去)
  order: 'desc',
  // 1 リクエストで指定できる最大期間: 1ヶ月 (30日)
  range: (30 * 24 - 1) * 24 * 60 * 60 * 1000, // 30 days in milliseconds
  // range を利用するため from / to の指定が必須
  requiresRange: true,
  // API 種別キー
  type: 'spot-trade-history',
} as const satisfies ApiConfig
